import { Component } from 'react';
import styled, { css } from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';

export interface IModuleTitleLinkAnchorProps {
  linkText: string;
  linkURL: string;
  dataClParams: string;
  linkTargetBlank: boolean; // リンクを別タブで開く場合
  isCurrent: boolean;
}

interface IDefaultProps {
  linkTargetBlank: boolean;
}

type IProps = IModuleTitleLinkAnchorProps;

const Link = styled.a<{ $isCurrent: boolean }>`
  display: block;
  padding: 0 8px;
  font-size: ${fontSize.px14};

  ${({ $isCurrent, theme }) =>
    $isCurrent
      ? css`
          font-weight: bold;
          color: ${theme.news.palette.text_base_common};

          &:hover {
            color: ${theme.news.palette.link_hover_pc};
          }
        `
      : ''}
`;

export default class ModuleTitleLinkAnchor extends Component<IProps> {
  public static defaultProps: IDefaultProps = {
    linkTargetBlank: false
  };
  /**
   *
   */
  public render() {
    return (
      <Link
        href={this.props.linkURL}
        data-cl-params={this.props.dataClParams}
        $isCurrent={this.props.isCurrent}
        target={this.props.linkTargetBlank ? '_blank' : ''}
      >
        {this.props.linkText}
      </Link>
    );
  }
}
